export default {"src":"/_next/static/media/bank-icon.3afe2bf5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};